import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { extendCommonStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../contexts/stylesheet.js";
import { useA11yId } from "../../hooks/useA11yId.js";
import { PlainAntdIconAsSvg } from "../plainAntdIconAsSvg.js";
const AccordionList = (param)=>{
    let { children } = param;
    const { AccordionList } = useStylesheet().extend(...extendCommonStylesheet);
    return /*#__PURE__*/ _jsx(AccordionList, {
        children: children
    });
};
const AccordionItem = (param)=>{
    let { children, title, icon, iconExpanded, expandable = true } = param;
    const { accordionArrow, AccordionDescription, AccordionItem, AccordionButton, AccordionTitle, accordionItemActive, accordionItemDisabled } = useStylesheet().extend(...extendCommonStylesheet);
    const [expanded, setExpanded] = useState(false);
    const a11yExpanded = useA11yId();
    return /*#__PURE__*/ _jsxs(AccordionItem, {
        onClick: ()=>expandable && setExpanded(!expanded),
        className: [
            expanded && accordionItemActive,
            !expandable && accordionItemDisabled
        ].filter(Boolean).join(" "),
        children: [
            /*#__PURE__*/ _jsxs(AccordionButton, {
                ...expandable ? {} : {
                    disabled: "disabled"
                },
                "aria-expanded": expanded,
                "aria-controls": a11yExpanded,
                href: "#",
                onClick: (e)=>e.preventDefault(),
                children: [
                    !!icon && /*#__PURE__*/ _jsx(PlainAntdIconAsSvg, {
                        icon: expanded && !!iconExpanded ? iconExpanded : icon,
                        className: accordionArrow
                    }),
                    /*#__PURE__*/ _jsx(AccordionTitle, {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                id: a11yExpanded,
                children: expanded && expandable && /*#__PURE__*/ _jsx(AccordionDescription, {
                    children: children
                })
            })
        ]
    });
};
export { AccordionList, AccordionItem };
